/**
 * 把「一格填了多個值」的那種欄位拆開。
 *
 * 客戶只有一個慣例：同一格要放多個值就用分號隔開。目前用在兩個地方 ——
 * 廠商的「區域」（一家廠商同時出現在好幾個分類底下）
 * 與「品牌名稱」（一家公司有多個品牌，客戶 2026-09-14 問了能不能設定多個）。
 * 填一個值的時候行為跟以前一樣，回傳只有一項的陣列。
 *
 * ⚠ 產品的分類**不要**用這支。產品是大／中／小三層路徑，
 * 三格各自填多值會有歧義：大分類填 A;B、中分類填 X;Y，
 * 到底是 A→X 與 B→Y 兩條路徑，還是四種組合？資料本身答不出來。
 * 產品要掛多個分類是複製成多列（一列一條路徑），顯示時再併回來，
 * 見 mergeDuplicateProducts。
 *
 * 🔴 分隔符號只認分號與直線，不要加逗號、頓號或 &。
 * 展商的分類名稱本身就帶這些符號，把它們當成分隔符號會將一個分類拆成好幾個，
 * 而且畫面上不會有任何錯誤訊息 —— 只會安靜地多出幾個沒人認得的分類，
 * 而原本那個分類底下的廠商全部不見。
 *
 * 為什麼只認分號與直線 —— 實際數過資料檔裡的 382 種分類名稱：
 *   逗號　18 種，例如 Accessories, components, parts, tools, cutters
 *   頓號　15 種，例如 夾治具、模具與相關設備
 *   &　　 9 種，例如 Certifications, quality inspection & testing
 *   分號　0 種
 *   直線　0 種
 * 斜線同樣是 0 種，但沒有收進來 —— CAD/CAM 這種寫法太常見，
 * 換一場展的資料就可能冒出來。
 *
 * 🔴 **全形的分號與直線也要認。**
 *
 * > **症狀：** 英文版好好的，切到繁體中文就有一批廠商從分類底下消失，
 * > 同時分類選單多出一個沒人認得的長名字（例如
 * > 「金屬切削工具機；零組件、工具、刀具、電控」整串當成一個分類）。
 * > 沒有任何錯誤訊息。
 * > **原因：** 同一批資料，英文版用半形 `;`，繁體中文版用全形 `；`。
 * > 中文輸入法預設打出來就是全形，所以這不是打錯，是必然會發生。
 * > 2026-09-14 客戶那份 TMTS 資料實際數過：英文版 26 筆用半形、
 * > 繁中版**同樣那 26 筆**用全形，一筆半形都沒有。
 * > **驗過：** 把繁中那 26 筆用全形分號拆開，拆出來的每一段都對得上
 * > 原本就存在的 7 種分類名稱，沒有多出任何一種 —— 所以全形分號在這份資料裡
 * > 純粹是分隔符號，不是分類名稱的一部分。
 *
 * ⚠ 全形逗號與全形頓號**不要**收，理由跟半形那幾個一樣：分類名稱本身就在用它們。
 */
const splitMultiValue = (value) => {
	if (!value) return [];

	return String(value)
		.split(/[;|；｜]/)
		.map((值) => 值.trim())
		.filter((值) => 值 !== '');
};

export default splitMultiValue;
